import { render, staticRenderFns } from "./ItemGroupDropdownField.vue?vue&type=template&id=2af6c0c2&scoped=true"
import script from "./ItemGroupDropdownField.vue?vue&type=script&lang=js"
export * from "./ItemGroupDropdownField.vue?vue&type=script&lang=js"
import style0 from "./ItemGroupDropdownField.vue?vue&type=style&index=0&id=2af6c0c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af6c0c2",
  null
  
)

export default component.exports